export const identityFullStory = (email: string, displayName: string) => {
  // eslint-disable-next-line no-prototype-builtins
  if (window.hasOwnProperty('FS')) {
    // @ts-ignore
    FS.identify(displayName, {
      displayName,
      email,
    });
  }
};
